<template>
    <v-container fluid>
        <v-layout class="devices-list px-8 mt-4" v-if="wiredList.length > 0" row>
            <v-flex
                class="devices-list__device"
                v-for="(wired, index) in wiredList"
                :key="`wiredColumn${index}`"
            >
                <ZigbeeDevice
                    :device="wired"
                    :controller="controllerId"
                    :first="index == 0"
                    :last="index == wiredList.length - 1"
                    :update="addDevice"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ZigbeeDevice from "@/components/controllers/ZigbeeDevice";

export default {
    name: "DebugControllerDevices",
    components: {ZigbeeDevice},
    props: {
        controllerId: {
            type: String,
            required: true,
        },
        controllerFullData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            controllerData: {},
            windowWidth: window.innerWidth,
            newDevices: [],
            wiredList: [],
        };
    },
    mounted() {
        this.controllerData = JSON.parse(JSON.stringify(this.controllerFullData));
        this.wiredList = this.controllerData.wired_devices;
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        addDevice(data) {
            let is_new = false;
            if (data.device.is_new) {
                is_new = true;
            }
            if (this.controllerData.wired_devices) {
                let index = this.controllerData.wired_devices.map(wired => {
                    return wired.inner_number
                }).indexOf(data.device.inner_number);
                if (index != -1) {
                    this.$set(this.controllerData.wired_devices, index, data.device);
                    is_new = false;
                } else if (this.newDevices) {
                    let index = this.newDevices.map(wired => {
                        return wired.inner_number
                    }).indexOf(data.device.inner_number);
                    if (index != -1) {
                        this.$set(this.newDevices, index, data.device);
                        is_new = false;
                    }
                }
            }
            if (is_new) {
                this.newDevices.unshift(data.device);
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        back() {
            if (this.controllerData && this.controllerData.hotel_room) {
                this.$router.push({name: "roompage", params: {id: this.controllerData.hotel_room.uid}});
            }
        },
    },
}
</script>

<style scoped>

</style>